export default "__VITE_ASSET__f6a6f51d__"